<template>
  <div class="filters">
    <div v-if="showLimitSelect" class="d-flex align-items-center">
      <span>{{ $t("display") }}</span>
      <select v-model="limit" :disabled="count === 0" class="form-control textStyle mx-2" @change="limitList">
        <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
      </select>
      <span>{{ $t("elements") }}</span>
    </div>
    <div v-if="showFilterInput" class="list__search position-relative">
      <InputTypeComponent :model="keywordSearch" @input="searchDebounced" />
    </div>
  </div>
</template>

<script>
import InputTypeComponent from "@/components/form/InputTypeComponent.vue";

export default {
  name: "FiltersDataTableComponent",
  components: { InputTypeComponent },
  props: {
    count: {
      type: Number,
      required: true,
    },
    defaultLimit: {
      type: Number,
      required: true,
    },
    showFilterInput: {
      type: Boolean,
      required: true,
    },
    showLimitSelect: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["limitList", "search"],
  data() {
    return {
      limit: this.defaultLimit,
      options: [5, 10, 25, 50],
      keywordSearch: {
        vars: {
          name: "keyword",
          value: "",
          id: "keyword",
          required: false,
          block_prefixes: ["filter", "text"],
          disabled: false,
          attr: {
            placeholder: this.$t("filter"),
          },
          row_attr: {
            class: "h-100",
          },
        },
      },
    };
  },
  computed: {
    searchDebounced() {
      return this.debounce(this.search, 500);
    },
  },
  methods: {
    limitList() {
      this.$emit("limitList", this.limit);
    },

    search() {
      this.$emit("search", this.keywordSearch.vars.value);
    },

    debounce(fn, delay = 300) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  padding-bottom: 5px;

  .form-control {
    width: 50px;
    height: 35px;
    padding: 0 10px;
    font-weight: 700;
  }
}
</style>
